// Constants
import { RTL_LANGUAGES } from 'constants/generic'

// Utility: Text > Camel case
function camelCase (text) {
	if (!text || typeof text !== 'string') return text
  return text.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
    return index === 0 ? word.toLowerCase() : word.toUpperCase()
  }).replace(/\s+/g, '')
}

// Utility: Text > Camel case enumeration
function camelCaseEnumeration (text) {
	if (!text || typeof text !== 'string' || !checkIfEnumeration(text)) return text
	return text
		.toLowerCase()
		.replace(/_+(\w|$)/g, (_, matchedText) => matchedText.toUpperCase())
}

// Utility: Text > Camel case slug
function camelCaseSlug (text) {
	if (!text || typeof text !== 'string') return text
	return text.replace(/-([a-z])/g, match => match[1].toUpperCase())
}

// Utility: Text > Check if enumeration
function checkIfEnumeration (text) {
	if (!text || typeof text !== 'string') return false
	return Array
		.from(text)
		.every(character => character === '_' || !!character.match(/[A-Z]/))
}

// Utility: Text > Conjugate
function conjugate (texts, { character = ' ', language = 'en', willAddSpaceAfter = false, willAddSpaceBefore = false } = {}) {
	let pieces = []
	texts.forEach((text, textIndex) => {
		pieces.push(text)
		if (textIndex !== texts.length - 1) {
			if (willAddSpaceBefore) pieces.push(' ')
			pieces.push(character)
			if (willAddSpaceAfter) pieces.push(' ')
		}
	})
	if (RTL_LANGUAGES.includes(language)) pieces = pieces.reverse()
	return pieces.join('')
}

// Utility: Text > Sentence case
function sentenceCase (text, locale = 'en') {
	if (!text) return text
	return uppercaseFirst(
		text
			.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
			.join(' '),
		{ locale, willLowercaseBefore: true }
	)
}

// Utility > Text > Slug
function slug (text) {
	if (!text || typeof text !== 'string') return text
  return String(text)
    .normalize('NFKD') // Splits accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // Removes all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // Trims leading or trailing whitespace
    .toLowerCase() // Converts to lowercase
    .replace(/[^a-z0-9 -]/g, '') // Removes non-alphanumeric characters
    .replace(/\s+/g, '-') // Replaces spaces with hyphens
    .replace(/-+/g, '-') // Removes consecutive hyphens
}

// Utility: Text > Truncate text
function truncateText (text, limit) {
	if (!text || typeof text !== 'string') return
	if (text.length <= limit) return text
	const formattedText = text.replace(/\s/, ' ').trim()
	if (/\s/.test(formattedText.charAt(limit))) return `${formattedText.slice(0, limit)}...` // If the next character is space
	const truncatedText = formattedText.slice(0, limit)
	return `${truncatedText.slice(0, Math.min(limit, truncatedText.lastIndexOf(' ')))}...`
}

// Utility: Text > Uppercase first
function uppercaseFirst (text, { locale = 'en', willLowercaseBefore = false } = {}) {
	if (!text || typeof text !== 'string') return
	if (willLowercaseBefore) text = text.toLocaleLowerCase(locale)
	return text.charAt(0)[locale ? 'toLocaleUpperCase' : 'toUpperCase'](locale) + text.slice(1)
}

// Export
export {
	camelCase,
	camelCaseEnumeration,
	camelCaseSlug,
	checkIfEnumeration,
	conjugate,
	sentenceCase,
	slug,
	truncateText,
	uppercaseFirst
}
